module.exports = __webpack_public_path__ + "static/media/gongniu.f36282e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/gongniu.mp4
// module id = xeRH
// module chunks = 0